import triggerToast from "./notifications";

const handleApiError = (err) => {
  if (err && err.response && err.response.data &&
    err.response.data.errorCode) {
    let {errorCode} = err.response.data;
    errorCode = parseInt(errorCode);

    switch (errorCode) {
      case 1:
        triggerToast("Otp is invalid or expired. Kindly generate new otp");
        break;
      case 2:
        triggerToast("Captcha Failed! Please refresh the page and try again");
        break;
      case 3:
        triggerToast("The email you provided is already subscribed");
        break;
      case 4:
        triggerToast("The phone number you provided is already used");
        break;
      default:
        triggerToast("Something went wrong. Please try again");
    }
  } else {
    triggerToast("Something went wrong. Please try again");
  }
};

export default handleApiError;
